import {
    CLAPI
} from '../clchart/cl.api.js'
import { formatFloat } from '../clchart/cl.utils.js'
import * as DATAS from '../datas/transdata.js'

// 这里存放一些公共的资源性数据

export const FWIDTH = 130

export const newbar_fields = 'code,msecstamp,agop,open,maxp,minp,newp,sumv,summ'

export const CHART_HEAD_INFOS = {
    style: 'horizontal', 
    title: {
        width: FWIDTH,
        label: '分类',
    },
    ctrls: []
}

export function initHeadCtrl(title) {
    if (title !== undefined) {
        CHART_HEAD_INFOS.title.label = title
    }
    CHART_HEAD_INFOS.ctrls = []
}
export function incrHeadCtrl(ctrlname) {
    CHART_HEAD_INFOS.ctrls.push({
        label: ctrlname,
        clickValue: ctrlname,
    })
}


export const CHART_LEFT_DATES = {
    style: 'vertical', // 'vertical'
    title: {
        label: '日期',
        height: 23,
    },
    ctrls: []
}

export function initDateCtrl(title) {
    if (title !== undefined) {
        CHART_LEFT_DATES.title.label = title
    }
    CHART_LEFT_DATES.ctrls = []
}
export function incrDateCtrlLeft(index, fname, vrate) {
    // console.log(index, fname);
    const info = {
        color : CLAPI.getLineColor(index),
        label: fname,
        align : 'left',
        clickValue: fname,
        value : [],
    }
    if (vrate !== undefined) {
        let clr = 'txt'
        if (vrate > 0) {
            clr = 'red'
        }
        if (vrate < 0) {
            clr = 'green'
        }
        info.value.push({
            label : formatFloat(Math.abs(vrate) * 100.0, 1, 4) + '%',
            color : clr,
        })
    }
    CHART_LEFT_DATES.ctrls.push(info)
}

export function incrDateCtrl(index, fname, align) {
    // console.log(index, fname);
    const info = {
        color : CLAPI.getLineColor(index),
        label: fname,
        align : align ?? 'center',
        clickValue: fname,
        value : [],
    }
    CHART_LEFT_DATES.ctrls.push(info)
}

export const CHART_LEFT_TASKS = {
    style: 'vertical', // 'vertical'
    title: {
        label: '任务列表',
        height: 23,
    },
    ctrls: []
}
export function initTaskCtrl(title) {
    if (title !== undefined) {
        CHART_LEFT_TASKS.title.label = title
    }
    CHART_LEFT_TASKS.ctrls = []
}
export function incrTaskCtrl(index, fname, align) {
    // console.log(fname);
    CHART_LEFT_TASKS.ctrls.push({
        color : CLAPI.getLineColor(index),
        label : fname,
        align : align ?? 'center',
        clickValue: fname,
    })
}
export function incrTaskCtrlLeft(index, fname, vrate) {
    // console.log(index, fname);
    const info = {
        color : CLAPI.getLineColor(index),
        label: fname,
        align : 'left',
        clickValue: fname,
        value : [],
    }
    if (vrate !== undefined) {
        let clr = 'txt'
        if (vrate > 0) {
            clr = 'red'
        }
        if (vrate < 0) {
            clr = 'green'
        }
        info.value.push({
            label : formatFloat(Math.abs(vrate) * 100.0, 1, 4) + '%',
            color : clr,
        })
    }
    CHART_LEFT_TASKS.ctrls.push(info)
}
